import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../Context';

import { BlackoutPeriodRule } from '../../../../types/Rules';

const BlackoutTo = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const ruleValue = rules.filter(r => r.type === 'blackout_period')[0] as
    | BlackoutPeriodRule
    | undefined;

  const dateObject = ruleValue?.end ? DateTime.fromISO(ruleValue.end) : null;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='rule-blackout-to-input'
        id='rule-blackout-to-input'
        label={<>To</>}
        type='date'
        min={ruleValue?.start}
        required
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            // Remove the date
            handleRuleChange(
              {
                type: 'blackout_period',
                ...ruleValue,
                end: '',
              },
              true,
            );
          } else {
            const date = new Date(value);
            handleRuleChange({
              type: 'blackout_period',
              ...ruleValue,
              end: DateTime.fromJSDate(date).endOf('day').startOf('second').toISO() as string,
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default BlackoutTo;
